import React from "react";
import { CheckIcon } from "lucide-react";
type CheckListProps = {
  items: string[];
  tone?: "light" | "dark";
  columns?: boolean;
};
export function CheckList({
  items,
  tone = "light",
  columns = false
}: CheckListProps) {
  const dark = tone === "dark";
  return <ul className={`grid gap-x-8 gap-y-3 ${columns ? "md:grid-cols-2" : ""}`} data-id="element-75" data-mp="38no22i6lwa9w">
      {items.map(item => <li key={item} className={`flex items-start gap-3 text-[16px] leading-snug ${dark ? "text-white/90" : "text-navy-900/85"}`} data-id="element-76" data-mp="33ob4p3i3zkt2">
          <CheckIcon className={`mt-0.5 h-5 w-5 shrink-0 ${dark ? "text-gold-400" : "text-cta"}`} strokeWidth={3} aria-hidden data-id="element-77" data-mp="2ywtd361z6wkr" />
          {item}
        </li>)}
    </ul>;
}